import { v4 as uuidv4 } from 'uuid';

export function Link(props = {}, childrenComponents = []) {
	const newProps = props;
	if (newProps?.displayMode == 'button') {
		newProps.buttonProps = {
			size: props?.buttonProps?.size || 'regular',
			variant: props?.buttonProps?.variant || 'primary',
		};
	}
	return {
		componentName: 'Link',
		componentId: uuidv4(),
		props: Object.assign(
			{
				label: 'Label padrão',
				href: '',
				scrollTo: '#',
				target: '_self',
				displayMode: 'anchor',
				rel: '',
			},
			newProps,
		),
		childrenComponents,
	};
}
